module.exports = __webpack_public_path__ + "img/073420.8dcf48c5.png";